import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { BaseService } from '../../lib-shared/services/base.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ProvincesService extends BaseService {
    constructor(http, injector) {
        super(http, injector, `${environment.apiDomain.dapFoodEndPoint}/Provinces`);
    }
    Save(item) {
        return this._http
            .post(this.serviceUri, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
    Gets(key, offset, limit, sortField, isAsc = false) {
        const queryString = `${this.serviceUri}?key=${key}&offset=${offset}&limit=${limit}&sortField=${sortField}&isAsc=${isAsc}`;
        return this.defaultGet(queryString);
    }
    ChangeDeleted(item) {
        return this._http
            .post(this.serviceUri + '/ChangeDeleted/' + item.id, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
    GetShort() {
        const queryString = `${this.serviceUri}/GetShort`;
        return this.defaultGet(queryString);
    }
    GetShortProduct(idRegions, isSellApp) {
        const queryString = `${this.serviceUri}/GetShortProduct?idRegions=${idRegions}&isSellApp=${isSellApp}`;
        return this.defaultGet(queryString);
    }
    Autocomplete(key, idProvince, idDistrict, idWard, offset, limit) {
        const queryString = `${this.serviceUri}/Autocomplete?key=${key}&idProvince=${idProvince}&idDistrict=${idDistrict}&idWard=${idWard}&offset=${offset}&limit=${limit}`;
        return this.defaultGet(queryString);
    }
}
ProvincesService.ngInjectableDef = i0.defineInjectable({ factory: function ProvincesService_Factory() { return new ProvincesService(i0.inject(i1.HttpClient), i0.inject(i0.INJECTOR)); }, token: ProvincesService, providedIn: "root" });
